  
  /**
  * Header Buttons
  * Open/close offcanvas menus on click of header buttons
 */
export const headerButtons = () => {
    const headerHamburger = document.querySelector('.hamburger');
    const sidebarMenu = document.querySelector('.side-navbar');
    const closeButton = sidebarMenu?.querySelector('.btn-close');

    const dropdownToggles = document.querySelectorAll('.dropdown-toggle-cs');

    dropdownToggles.forEach((toggle) => {
        const dropdownMenu = toggle.nextElementSibling; // Get corresponding .dropdown-cs
        const arrow = toggle.querySelector('.arrow'); // Get the arrow image inside the toggle
        let isLanguageOpen = false;

        const toggleLanguage = () => {
            isLanguageOpen = !isLanguageOpen;
            if (isLanguageOpen) {
                slideDown(dropdownMenu);
                if (arrow) arrow.style.transform = "rotate(-180deg)"; // Rotate arrow only if it exists
                document.addEventListener('click', closeLanguageOnClickOutside);
            } else {
                slideUp(dropdownMenu);
                if (arrow) arrow.style.transform = "rotate(-90deg)"; // Reset arrow only if it exists
                document.removeEventListener('click', closeLanguageOnClickOutside);
            }
        };

        const closeLanguageOnClickOutside = (event) => {
            if (!toggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
                isLanguageOpen = false;
                slideUp(dropdownMenu);
                if (arrow) arrow.style.transform = "rotate(-90deg)"; // Reset arrow only if it exists
                document.removeEventListener('click', closeLanguageOnClickOutside);
            }
        };

        // Helper function to slide down an element
        function slideDown(element) {
            element.style.display = 'block';
            element.style.height = 'auto';
        }

        // Helper function to slide up an element
        function slideUp(element) {
            element.style.display = 'none';
        }

        toggle.addEventListener('click', (event) => {
            event.stopPropagation();
            toggleLanguage();
        });

        // Ensure dropdown closes when clicking on a language option
        const languageOptions = dropdownMenu.querySelectorAll('li');
        languageOptions.forEach((option) => {
            option.addEventListener('click', () => {
                isLanguageOpen = false;
                slideUp(dropdownMenu);
                if (arrow) arrow.style.transform = "rotate(-90deg)"; // Reset arrow only if it exists
                document.removeEventListener('click', closeLanguageOnClickOutside);
            });
        });
    });


    if (!headerHamburger || !sidebarMenu) return;

    let isOpen = false; // Track menu state

    // Function to toggle sidebar
    const toggleMenu = () => {
        isOpen = !isOpen; // Toggle state

        if (isOpen) {
        sidebarMenu.classList.add('open');
        headerHamburger.classList.add('active');
        document.addEventListener('click', closeOnClickOutside); // Add event listener
        } else {
        closeMenu();
        }
    };

    // Function to close sidebar
    const closeMenu = () => {
        isOpen = false; // Reset state
        sidebarMenu.classList.remove('open');
        headerHamburger.classList.remove('active');
        document.removeEventListener('click', closeOnClickOutside); // Remove event listener
    };

    // Close when clicking outside the sidebar
    const closeOnClickOutside = (event) => {
        if (!sidebarMenu.contains(event.target) && !headerHamburger.contains(event.target)) {
        closeMenu();
        }
    };

    // Click event on hamburger icon
    headerHamburger.addEventListener('click', toggleMenu);

    // Click event on close button
    if (closeButton) {
        closeButton.addEventListener('click', closeMenu);
    }
};

export const handleMenuActive = () => {
    const menuLinks = document.querySelectorAll('.menubar .nav-link');
    const sideLinks = document.querySelectorAll('.side-navbar .nav-link');
    const breadcrumbLink = document.querySelectorAll('.pl_breadcrumb a');
    const homeLink = document.querySelectorAll('.navbar-nav .home');
    

    const navLinks = [...menuLinks, ...sideLinks, ...breadcrumbLink];


    // Function to remove 'active' class from all parents
    const removeActiveClassesMenu = () => {
        menuLinks.forEach(link => {
            if (link.parentElement) {
                link.parentElement.classList.remove('active');
            }
        });
    }
    const removeActiveClassesSide = () => {
        sideLinks.forEach(link => {
            if (link.parentElement) {
                link.parentElement.classList.remove('active');
            }
        });
    };

    const removeActiveClassesBreadcrumb = () => {
        breadcrumbLink.forEach(link => {
            if (link.parentElement) {
                link.parentElement.classList.remove('active');
            }
        });
    };
    menuLinks.forEach(link => {
        link.addEventListener('click', (event) => {
            removeActiveClassesMenu(); // Remove 'active' from all before adding to the clicked one
            link.parentElement.classList.add('active');
        });
    });
    sideLinks.forEach(link => {
        link.addEventListener('click', (event) => {
            removeActiveClassesSide(); // Remove 'active' from all before adding to the clicked one
            link.parentElement.classList.add('active');
        });
    });
    breadcrumbLink.forEach(link => {
        link.addEventListener('click', (event) => {
            removeActiveClassesMenu(); // Remove 'active' from all before adding to the clicked one
            removeActiveClassesSide();
            homeLink.forEach(link =>{
                link.classList.add('active');
            })
        });
    });
    // Set active class based on current URL path
    const currentPath = window.location.pathname;
    menuLinks.forEach(link => {
        if (link.getAttribute('href') === currentPath) {
            removeActiveClassesMenu();
            link.parentElement.classList.add('active');
        }
    });
    sideLinks.forEach(link => {
        if (link.getAttribute('href') === currentPath) {
            removeActiveClassesSide();
            link.parentElement.classList.add('active');
        }
    });
};


export const animateSmoothTransition = () => {
    const carouselElement = document.querySelector("#home-carousel");
  
    if (carouselElement) {
        carouselElement.addEventListener("slid.bs.carousel", () => {
            // Find the active carousel item
            const activeItem = document.querySelector(".carousel-item.active");
            
            // Ensure activeItem exists before accessing elements
            if (!activeItem) return;

            const h2Element = activeItem.querySelector("h2");
            const pElement = activeItem.querySelector("p");

            // Ensure h2 and p exist before modifying styles
            if (h2Element) {
                h2Element.style.animation = "none";
                setTimeout(() => {
                    h2Element.style.animation = "";
                }, 10);
            }

            if (pElement) {
                pElement.style.animation = "none";
                setTimeout(() => {
                    pElement.style.animation = "";
                }, 10);
            }
        });
    }

    return () => {
        if (carouselElement) {
            carouselElement.removeEventListener("slid.bs.carousel", () => {});
        }
    };
};


export const initializeCarouselProgress = (setProgress, setIntervalTime) => {
    const carouselElement = document.querySelector("#home-carousel");
  
    const updateProgress = () => {
      setProgress(0);
  
      let activeItem = document.querySelector(".carousel-item.active");
      
      // Ensure activeItem is not null before accessing attributes
      if (!activeItem) return;
  
      let duration = 5000;
      //console.log("Duration: " + duration);

      setIntervalTime(duration);
  
      let start = 0;
      let step = 100 / (duration / 50); // Update every 50ms
  
      const progressInterval = setInterval(() => {
        start += step;
        if (start >= 100) {
          clearInterval(progressInterval);
          setProgress(100);
          
          //console.log("End of video");
          //carousel.next();
        } else {
          setProgress(start);
        }
      }, 50);
    };

    if (carouselElement) {
      carouselElement.addEventListener("slid.bs.carousel", updateProgress);
      updateProgress(); // Initialize on first load
    }
    
    return () => {
      if (carouselElement) {
        carouselElement.removeEventListener("slid.bs.carousel", updateProgress);
      }
    };
  };


export const triggerFadeInOnScroll = () => {
    const wrappers1 = document.querySelectorAll('.section_home_wash .wrapper');
    const paragraphs1 = document.querySelectorAll('.section_home_wash p');
    const wrappers2 = document.querySelectorAll('.section_home_dry .wrapper');
    const paragraphs2 = document.querySelectorAll('.section_home_dry p');
    const rect1 = document.querySelectorAll('.section_home_wash .rect');
    const h21 = document.querySelectorAll('.section_home_wash h2');
    const rect2 = document.querySelectorAll('.section_home_dry .rect');
    const h22 = document.querySelectorAll('.section_home_dry h2');
    const rect3 = document.querySelectorAll('.section_home_creation .rect');
    const h23 = document.querySelectorAll('.section_home_creation h2');
    const paragraphs3 = document.querySelectorAll('.section_home_creation p');
    const h3 = document.querySelectorAll('.section_home_creation .left h3');
    const lis1 = document.querySelectorAll('.section_home_creation .left li'); 
    const h32 = document.querySelectorAll('.section_home_creation .right h3');
    const lis2 = document.querySelectorAll('.section_home_creation .right li');

    // Combine NodeLists into a single array
    const elements = [...wrappers1, ...paragraphs1, ...wrappers2, ...paragraphs2, ...rect1, ...h21, ...rect2, ...h22, ...rect3, ...h23, ...paragraphs3, ...h3, ...lis1, ...h32, ...lis2];
  
    if (!elements.length) {
      console.warn("No target .wrapper elements found.");
      return;
    }
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Add 'show' class when intersecting; remove otherwise
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
          } else {
            // entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.5 }
    );
  
    elements.forEach((el) => observer.observe(el));
  };

  export const triggerFadeInOnScroll2 = () => { 
    const rect = document.querySelectorAll('.section_selfwash_laundry .rect');
    const h2 = document.querySelectorAll('.section_selfwash_laundry h2');
    const p1 = document.querySelectorAll('.section_selfwash_laundry .content .p1');
    const leftp1 = document.querySelectorAll('.section_selfwash_laundry .left .p1');
    const leftp2 = document.querySelectorAll('.section_selfwash_laundry .left .p2');
    const list1 = document.querySelectorAll('.section_selfwash_laundry .content li');
    const img = document.querySelectorAll('.section_selfwash_laundry .right img');
    const try_garentee1 = document.querySelectorAll('.section_selfwash_laundry .content .try_garentee');
    const subtitle = document.querySelectorAll('.section_selfwash_why .subtitle');
    const leftdiv1 = document.querySelectorAll('.section_selfwash_why .content .left');
    const rightdiv1 = document.querySelectorAll('.section_selfwash_why .content .right');
    const try_garentee2 = document.querySelectorAll('.section_selfwash_why .content .try_garentee');

    const elements = [...rect, ...h2, ...p1, ...leftp1, ...leftp2, ...list1, ...img, ...subtitle, ...leftdiv1, ...rightdiv1, ...try_garentee1, ...try_garentee2];

    const observer = new IntersectionObserver(entries => {
        let delay = 0;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add("animated");
                }, delay);

                delay += 800; // Stagger appearance (0.8s between each)
            }else{
                if (entry.target.classList.contains("try_garentee")){
                    entry.target.classList.remove("animated");
                }
            }
        });
    }, { threshold: 0.3 });

    elements.forEach(el => observer.observe(el));
};

export const triggerFadeInOnScroll3 = () => { 
    const rect = document.querySelectorAll('.section_selfdry_laundry .rect');
    const h2 = document.querySelectorAll('.section_selfdry_laundry h2');
    const p1 = document.querySelectorAll('.section_selfdry_laundry .content .p1');
    const p2 = document.querySelectorAll('.section_selfdry_laundry .content .p2');
    const h3 = document.querySelectorAll('.section_selfdry_laundry .content h3');
    const list1 = document.querySelectorAll('.section_selfdry_laundry .content li');
    const try_garentee1 = document.querySelectorAll('.section_selfdry_laundry .content .try_garentee');
    const subtitle = document.querySelectorAll('.section_selfdry_why .subtitle');
    const leftdiv1 = document.querySelectorAll('.section_selfdry_why .content .left');
    const rightdiv1 = document.querySelectorAll('.section_selfdry_why .content .right');
    const try_garentee2 = document.querySelectorAll('.section_selfdry_why .content .try_garentee');

    const elements = [...rect, ...h2, ...p1, ...h3, ...p2, ...list1, ...subtitle, ...leftdiv1, ...rightdiv1, ...try_garentee1, ...try_garentee2];

    const observer = new IntersectionObserver(entries => {
        let delay = 0;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add("animated");
                }, delay);

                delay += 800; // Stagger appearance (0.8s between each)
            }else{
                if (entry.target.classList.contains("try_garentee")){
                    entry.target.classList.remove("animated");
                }
            }
        });
    }, { threshold: 0.3 });

    elements.forEach(el => observer.observe(el));
};

export const triggerFadeInOnScrollPricing = () => { 

    const h21 = document.querySelectorAll('.section_pricing_top .video-container h2');
    const h4 = document.querySelectorAll('.section_pricing_top .video-container h4');
    const rect = document.querySelectorAll('.section_pricing_middle .rect');
    const h22 = document.querySelectorAll('.section_pricing_middle h2');
    const p1 = document.querySelectorAll('.section_pricing_middle .content .p1');
    const p2 = document.querySelectorAll('.section_pricing_middle .content .p2');
    const p3 = document.querySelectorAll('.section_pricing_middle .content .p3');
    const tb1 = document.querySelectorAll('.section_pricing_middle .content .tb1');
    const tb2 = document.querySelectorAll('.section_pricing_middle .content .tb2');
    const col1 = document.querySelectorAll('.section_pricing_middle .content .tb3 .col1');
    const img = document.querySelectorAll('.section_pricing_middle .content .tb3 .col2 img');
    const try_garentee = document.querySelectorAll('.section_pricing_middle .content .try_garentee');

    const elements = [...h21, ...h4, ...rect, ...h22, ...p1, ...p2, ...p3, ...tb1, ...tb2, ...col1, ...img, ...try_garentee];

    const observer = new IntersectionObserver(entries => {
        let delay = 0;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add("animated");
                }, delay);

                delay += 800; // Stagger appearance (0.8s between each)
            }else{
                if (entry.target.classList.contains("try_garentee")){
                    entry.target.classList.remove("animated");
                }
            }
        });
    }, { threshold: 0.3 });

    elements.forEach(el => observer.observe(el));
};

export const triggerFadeInOnScrollContact = () => { 

    const h2 = document.querySelectorAll('.section_contact_top h2');
    const h3 = document.querySelectorAll('.section_contact_top h3');
    const left = document.querySelectorAll('.section_contact_middle .left');
    const right = document.querySelectorAll('.section_contact_middle .right');

    const elements = [...h2, ...h3, ...left, ...right];

    const observer = new IntersectionObserver(entries => {
        let delay = 0;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add("animated");
                }, delay);

                delay += 800; // Stagger appearance (0.8s between each)
            }else{
                if (entry.target.classList.contains("try_garentee")){
                    entry.target.classList.remove("animated");
                }
            }
        });
    }, { threshold: 0.3 });

    elements.forEach(el => observer.observe(el));
};
  

// Ensure function runs when DOM is fully loaded
document.addEventListener("DOMContentLoaded", triggerFadeInOnScroll);
document.addEventListener("DOMContentLoaded", triggerFadeInOnScroll2);
document.addEventListener("DOMContentLoaded", triggerFadeInOnScroll3);
document.addEventListener("DOMContentLoaded", triggerFadeInOnScrollPricing);
document.addEventListener("DOMContentLoaded", triggerFadeInOnScrollContact);

  
  

  
  